import { prefix } from "./utils";

export const AREA = prefix("area");
export const AREA_PIECES = prefix("area-pieces");
export const AREA_PIECE = prefix("area-piece");
export const AVOID = prefix("avoid");
